<div class="cart-container" [@fadeInUp]>
  <h1>{{ t('shoppingCart') }}</h1>

  <!-- Shared policy modal instance (hidden buttons); used by links below -->
  <app-policy-modal #policyModal [showButtons]="false"></app-policy-modal>

  <!-- Authentication Status Prompt (visible when logged out) -->
  <div class="auth-status" *ngIf="!isLoggedIn">
    <div class="empty-cart">
      <div class="empty-cart-graphic"><i class="fas fa-shopping-cart"></i></div>
      <h2>{{ t('missingCartItems') }}</h2>
      <p>{{ t('loginToSeeItems') }}</p>
      <div class="auth-buttons">
        <button (click)="goToLogin()" class="btn-primary">{{ t('login') }}</button>
      </div>
      <div class="policy-buttons"></div>
    </div>
  </div>

  <!-- Footer-like help/links section for logged-out users -->
  <div class="auth-help-footer" *ngIf="!isLoggedIn">
    <div class="links-left">
      <a href="#" (click)="$event.preventDefault(); policyModal.openPrivacy()">{{ t('privacyPolicy') }}</a>
      <span>|</span>
      <a href="#" (click)="$event.preventDefault(); policyModal.openTerms()">{{ t('termsAndConditions') }}</a>
      <span>|</span>
      <a href="#" (click)="$event.preventDefault(); policyModal.openRefund()">{{ t('cancellationAndRefund') }}</a>
      <span>|</span>
      <a href="#" (click)="$event.preventDefault(); policyModal.openShipping()">{{ t('shippingAndDelivery') }}</a>
    </div>
    <div class="links-right">
      <span>{{ t('needHelpVisit') }}</span>
      <a routerLink="/support">{{ t('contactSupport') }}</a>
    </div>
  </div>

  <!-- Dose Eligibility Status -->
  <ng-container *ngIf="isLoggedIn">
     <div class="eligibility-status" *ngIf="doseEligibility">
         <div class="status-card">
           <h3>{{ t('yourDoseProgress') }}</h3>
           <p class="status-text">{{ getEligibilityStatus() }}</p>
   
           <div class="progress-section">
             <div class="progress-bar">
               <div class="progress-fill" [style.width.%]="getDoseProgressPercentage()"></div>
             </div>
             <div class="progress-percentage">{{ getDoseProgressPercentage() | number:'1.0-1' }}%</div>
           </div>
   
           <!-- Dose Status Indicators -->
           <div class="dose-indicators">
             <div class="dose-indicator" *ngFor="let doseNum of totalProducts; let i = index" [attr.data-dose]="i+1"
               [style.border-color]="getDoseStatus(i+1).color">
               <div class="dose-circle" [style.background-color]="getDoseStatus(i+1).color">
                 {{ i + 1 }}
               </div>
               <div class="dose-label">{{ getProductNameByIndex(i) }}</div>
               <div class="dose-status" [style.color]="getDoseStatus(i + 1).color">
                 {{ getDoseStatus(i + 1).message }}
               </div>
             </div>
           </div>
         </div>
     </div>
   
    <!-- Cart Content -->
    <div class="cart-content" *ngIf="cartItems.length > 0; else emptyCart">
      <!-- First Row: Order Summary + Ongoing Offer -->
      <div class="first-row">
        <!-- Order Summary Column -->
        <div class="order-summary-column">
          <div class="cart-summary">
            <div class="summary-card">
              <h3><i class="fas fa-clipboard-list"></i> {{ t('orderSummary') }}</h3>
              
              <!-- Cart Items within Summary -->
              <div class="cart-items">
                <div class="cart-item" *ngFor="let item of cartItems" [class.invalid-item]="!canPurchaseDose(item.doseNumber)">
                  <div class="cart-item-content">
                    <div class="item-image">
                      <img [src]="getImageUrl(getFirstImage(item))" [alt]="getLocalizedName(item)" (error)="onImageError($event)">
                    </div>
            
                    <div class="item-details">
                      <h3>{{ getDisplayNameWithCategory(item) }}</h3>
                      <p class="dose-type">{{ getLocalizedDescription(item) }}</p>
                      
                      <!-- Items in box display -->
                      <p class="sub-products" *ngIf="getSubProducts(item)">
                        <span class="sub-products-label">{{ t('itemsInBox') || 'Items in box' }}:</span>
                        <span class="sub-products-list">{{ getSubProducts(item) }}</span>
                      </p>
            
                      <!-- Warning for invalid items -->
                      <div class="warning-message" *ngIf="!canPurchaseDose(item.doseNumber)">
                        <i class="fas fa-exclamation-triangle"></i>{{ getInvalidItemWarning(item) }}
                      </div>

                      <!-- Mobile price and actions -->
                      <div class="mobile-price-actions">
                        <div class="mobile-price">
                          <div class="price-container">
                            <div class="price">₹{{ getItemUnitPrice(item) | number:'1.2-2' }}</div>
                            <div class="original-price" *ngIf="hasOfferPrice(item)">
                              <span class="og-price">₹{{ getItemUnitOriginalPrice(item)! | number:'1.2-2' }}</span>
                            </div>
                          </div>
                          <div class="price-total" *ngIf="item.cartQuantity > 1">
                            <span class="total-label">{{ t('total') || 'Total' }}:</span>
                            <span class="total-amount">₹{{ getItemTotal(item) | number:'1.2-2' }}</span>
                          </div>
                        </div>
                        <div class="mobile-actions">
                          <button (click)="removeItem(item.id, item.selectedCategoryId)" class="remove-btn"><i class="fas fa-trash-alt"></i> {{ t('remove') }}</button>
                        </div>
                      </div>
                    </div>
            
                    <div class="item-price-section">
                      <div class="item-price">
                        <div class="price-container">
                          <div class="price">₹{{ getItemUnitPrice(item) | number:'1.2-2' }}</div>
                          <div class="original-price" *ngIf="hasOfferPrice(item)">
                            <span class="og-price">₹{{ getItemUnitOriginalPrice(item)! | number:'1.2-2' }}</span>
                          </div>
                        </div>
                        <div class="price-total" *ngIf="item.cartQuantity > 1">
                          <span class="total-label">{{ t('total') || 'Total' }}:</span>
                          <span class="total-amount">₹{{ getItemTotal(item) | number:'1.2-2' }}</span>
                        </div>
                      </div>
            
                      <div class="item-actions">
                        <button (click)="removeItem(item.id, item.selectedCategoryId)" class="remove-btn"><i class="fas fa-trash-alt"></i> {{ t('remove') }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Order Summary Details -->
              <div class="summary-details">
                <div class="summary-row">
                  <span>{{ t('subtotal') }} ({{ cartItems.length }} {{ t('items') }}):</span>
                  <span>₹{{ subtotal | number:'1.2-2' }}</span>
                </div>
        
               <div class="summary-row combo-discount" *ngIf="discount > 0">
                 <span><i class="fas fa-gift"></i> Combo Offer (10% off):</span>
                 <span class="discount-amount">-₹{{ discount | number:'1.2-2' }}</span>
               </div>
        
                <div class="summary-row total">
                  <span>{{ t('total') }}:</span>
                  <span class="total-amount">₹{{ total | number:'1.2-2' }}</span>
                </div>
        
                <div class="combo-info" *ngIf="isComboOrder()">
                  <div class="combo-badge">
                    <i class="fas fa-gift"></i> {{ t('comboOfferApplied') }}
                  </div>
                  <p>{{ t('youreSaving', { amount: getComboSavings() }) }}</p>
                </div>
        
                <!-- Error Messages -->
                <div class="error-message" *ngIf="errorMessage">
                  <i class="fas fa-exclamation-triangle"></i> {{ errorMessage }}
                </div>
        
                <!-- Success Messages -->
                <div class="success-message" *ngIf="successMessage">
                  <i class="fas fa-check-circle"></i> {{ successMessage }}
                </div>
        
                <!-- Action Buttons -->
                <div class="action-buttons">
                  <button class="clear-cart-btn" (click)="clearCart()" *ngIf="cartItems.length > 0">
                    <i class="fas fa-trash-alt"></i> {{ t('clearCart') }}
                  </button>
                  <button class="checkout-btn" (click)="proceedToCheckout()"
                    [disabled]="!isLoggedIn || cartItems.length === 0 || errorMessage"
                    [class.disabled]="!isLoggedIn || cartItems.length === 0 || errorMessage">
                    <i class="fas fa-shopping-cart"></i> <span *ngIf="!isLoggedIn">{{ t('loginToCheckout') }}</span>
                    <span *ngIf="isLoggedIn && cartItems.length === 0">{{ t('cartIsEmpty') }}</span>
                    <span *ngIf="isLoggedIn && cartItems.length > 0 && !errorMessage">{{ t('proceedToCheckout') }}</span>
                    <span *ngIf="errorMessage">{{ t('cannotProceed') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      
        <!-- Ongoing Offer Column -->
        <div class="ongoing-offer-column">
          <div class="cart-summary">
            <div class="summary-card">
              <div class="offer-header">
                <h3>{{ t('ongoingOffer') }}</h3>
              </div>
              
              <div class="offer" [class.active]="isComboOrder()">
                <div class="offer-content">
                 
                  <div class="offer-description">
                    <h4>{{ getOfferTitle() }}</h4>
                    <p>{{ getOfferDescription() }}</p>
                  </div>
                  
                  <div class="offer-status" *ngIf="isComboOrder()">
                    <div class="status-icon"><i class="fas fa-check-circle"></i></div>
                    <p class="active-hint">Offer applied automatically.</p>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Second Row: Dose Information -->
      <div class="dose-info-row" *ngIf="isLoggedIn && cartItems.length > 0">
        <div class="dose-info">
          <div class="dose-info-header">
            <div class="header-icon"><i class="fas fa-clipboard-list"></i></div>
            <h3>{{ t('importantInformation') }}</h3>
            <div class="header-decoration"></div>
          </div>
          
          <div class="info-cards">
            <div class="info-card">
              <div class="card-icon"><i class="fas fa-sync-alt"></i></div>
              <div class="card-content">
                <h4>{{ t('sequentialTreatment') }}</h4>
                <p>{{ t('dosesMustBeTaken') }}</p>
              </div>
            </div>
            
            <div class="info-card">
              <div class="card-icon"><i class="fas fa-calendar-alt"></i></div>
              <div class="card-content">
                <h4>{{ t('daySupply') }}</h4>
                <p>{{ t('eachDoseProvides') }}</p>
              </div>
            </div>
            
            <div class="info-card">
              <div class="card-icon"><i class="fas fa-clock"></i></div>
              <div class="card-content">
                <h4>{{ t('noOverlap') }}</h4>
                <p>{{ t('completeOneDose') }}</p>
              </div>
            </div>
          </div>
          
          <!-- 40-Day Rule – always visible, full width -->
          <div class="info-card warning-card warning-card-full-width">
            <div class="card-icon warning-icon"><i class="fas fa-exclamation-triangle"></i></div>
            <div class="card-content">
              <h4>{{ t('counterResetInfoTitle') }}</h4>
              <p>{{ doseEligibility?.isCounterReset ? t('counterResetMessage') : t('counterResetInfoMessage') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <!-- Empty Cart Template -->
  <ng-template #emptyCart>
    <div class="empty-cart">
      <div class="empty-cart-icon"><i class="fas fa-shopping-cart"></i></div>
      <h2>{{ t('yourCartIsEmpty') }}</h2>
      <p>{{ t('startHeightJourney') }}</p>
      <button (click)="continueShopping()" class="shop-now-btn">{{ t('shopNow') }}</button>
    </div>
  </ng-template>
</div>
